var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "yoyo-container mx-auto min-h-screen pb-4 pb-[env(safe-area-inset-bottom)]",
      on: { click: _vm.handleClickOverlay },
    },
    [
      _c("navBar", {
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c("img", {
                  staticClass: "w-5 h-5",
                  attrs: { src: _vm.cardSrc, alt: "" },
                  on: { click: _vm.goToCart },
                }),
                _c("span", { staticClass: "text-sm mr-4" }, [
                  _vm._v("(" + _vm._s(_vm.cartItems.length) + ")"),
                ]),
                _c("img", {
                  staticClass: "w-5 h-5",
                  attrs: { src: _vm.mineSrc, alt: "" },
                  on: { click: _vm.goToMine },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "navBottom",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "rounded flex items-center justify-center relative overflow-visible bg-[#f7fafc] py-2",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md:w-2/5 w-5/7 min-h-12 rounded-full border border-gray-200 flex items-center justify-center pl-3 bg-white",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleSearch.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "w-4 h-4 mr-3",
                          attrs: { src: _vm.searchSrc, alt: "" },
                        }),
                        _vm._l(_vm.detailInfo.placeIconList, function (item) {
                          return _c("img", {
                            key: item,
                            staticClass: "w-5 h-4 mr-1",
                            attrs: {
                              src: _vm.imageBaseUrl + item,
                              alt: _vm.detailInfo.place,
                            },
                          })
                        }),
                        _c("van-search", {
                          staticClass: "flex-1 p-0 pl-2",
                          attrs: {
                            value: _vm.selectedRegion,
                            placeholder: _vm.$t("home.searchText"),
                          },
                          on: {
                            input: _vm.handleInput,
                            search: _vm.handleInputEnter,
                          },
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("product-options", {
        ref: "productOptions",
        attrs: { skus: _vm.detailInfo.packageList, isZh: _vm.isZh },
        on: { change: _vm.handleChange },
      }),
      _c("product-describe", {
        attrs: { detailInfo: _vm.detailInfo, isZh: _vm.isZh },
      }),
      _c("product-review", {
        attrs: { detailInfo: _vm.detailInfo, reviews: _vm.reviews },
      }),
      _c("div", { staticClass: "h-16" }),
      _c(
        "div",
        {
          staticClass:
            "fixed z-50 h-14 bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)] yoyo-container mx-auto",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center space-x-6 w-full lg:mx-4 lg:w-[calc(100%-2rem)] bg-white border-t border-gray-200 py-3 pr-3 pl-5",
            },
            [
              _c("van-icon", {
                attrs: {
                  name: _vm.detailInfo.favorite ? "like" : "like-o",
                  color: _vm.detailInfo.favorite ? "#ff7a00" : "#999",
                  size: "24",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleFavorite(_vm.item)
                  },
                },
              }),
              _c("van-icon", {
                staticClass: "text-gray-400",
                attrs: { name: "chat-o", size: "24" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleCustomService.apply(null, arguments)
                  },
                },
              }),
              _c(
                "div",
                {
                  staticClass: "w-full flex items-center justify-end space-x-3",
                },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "h-8 mr-2",
                      attrs: { type: "warning", round: "", color: "#ff7a00" },
                      on: { click: _vm.addToCart },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("products.addToCart")) + " ")]
                  ),
                  _c(
                    "van-button",
                    {
                      staticClass: "h-8",
                      attrs: { type: "danger", round: "", color: "#ff7a00" },
                      on: { click: _vm.buyNowNew },
                    },
                    [_vm._v(_vm._s(_vm.$t("products.buyNow")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass:
            "yoyo-container left-1/2 -translate-x-1/2 bg-transparent",
          attrs: { position: "bottom", round: "" },
          model: {
            value: _vm.showRegionPicker,
            callback: function ($$v) {
              _vm.showRegionPicker = $$v
            },
            expression: "showRegionPicker",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "p-3 lg:mx-4 lg:w-[calc(100%-2rem)] bg-white rounded-t-xl",
            },
            [
              _c(
                "h3",
                { staticClass: "text-lg font-medium mb-4 text-center" },
                [_vm._v(_vm._s(_vm.$t("products.selectRegion")))]
              ),
              _c(
                "div",
                { staticClass: "space-y-2 max-h-80 overflow-y-auto" },
                _vm._l(_vm.regions, function (region) {
                  return _c(
                    "div",
                    {
                      key: region.id,
                      staticClass:
                        "flex items-center p-3 cursor-pointer hover:bg-gray-50 rounded",
                      on: {
                        click: function ($event) {
                          return _vm.selectRegion(region)
                        },
                      },
                    },
                    [
                      _vm._l(region.placeIconList, function (item) {
                        return _c("img", {
                          key: item,
                          staticClass: "w-5 h-4 mr-3",
                          attrs: {
                            src: _vm.imageBaseUrl + item,
                            alt: region.place,
                          },
                        })
                      }),
                      _c("span", { staticClass: "text-sm" }, [
                        _vm._v(
                          _vm._s(_vm.isZh ? region.place : region.placeEn)
                        ),
                      ]),
                    ],
                    2
                  )
                }),
                0
              ),
            ]
          ),
        ]
      ),
      _c(
        "van-popup",
        {
          class: [
            "flex items-start justify-center yoyo-container home-popup",
            _vm.popupClass,
          ],
          style: _vm.popupVars,
          attrs: { position: "top" },
          model: {
            value: _vm.showPlaceList,
            callback: function ($$v) {
              _vm.showPlaceList = $$v
            },
            expression: "showPlaceList",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "md:w-2/5 w-5/7 h-140 bg-white rounded-2xl overflow-y-auto border border-gray-200 p-4",
            },
            [
              _vm.recentSearches.length > 0
                ? _c("div", { staticClass: "mb-6" }, [
                    _c(
                      "h3",
                      { staticClass: "text-sm font-medium text-gray-600 mb-3" },
                      [_vm._v(_vm._s(_vm.$t("home.recentSearch")))]
                    ),
                    _c(
                      "div",
                      { staticClass: "space-y-2" },
                      _vm._l(_vm.recentSearches, function (search) {
                        return _c(
                          "div",
                          {
                            key: search.id,
                            staticClass:
                              "flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleRecentSearch(search)
                              },
                            },
                          },
                          [
                            _vm._l(search.placeIconList, function (item) {
                              return _c("img", {
                                key: item,
                                staticClass: "w-5 h-4 mr-2",
                                attrs: {
                                  src: _vm.imageBaseUrl + item,
                                  alt: search.place,
                                },
                              })
                            }),
                            _c("span", { staticClass: "text-sm" }, [
                              _vm._v(
                                _vm._s(_vm.isZh ? search.place : search.placeEn)
                              ),
                            ]),
                          ],
                          2
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _c("div", [
                _c(
                  "h3",
                  { staticClass: "text-sm font-medium text-gray-600 mb-3" },
                  [_vm._v(_vm._s(_vm.$t("home.popularRecommend")))]
                ),
                _c(
                  "div",
                  { staticClass: "space-y-3" },
                  _vm._l(_vm.popularDestinations, function (destination) {
                    return _c(
                      "div",
                      {
                        key: destination.id,
                        staticClass:
                          "flex items-center cursor-pointer hover:bg-gray-50 p-2 rounded",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.handleDestinationClick(destination)
                          },
                        },
                      },
                      [
                        _vm._l(destination.placeIconList, function (item) {
                          return _c("img", {
                            key: item,
                            staticClass: "w-5 h-4 mr-1",
                            attrs: {
                              src: _vm.imageBaseUrl + item,
                              alt: destination.place,
                            },
                          })
                        }),
                        _c("span", { staticClass: "text-sm" }, [
                          _vm._v(
                            _vm._s(
                              _vm.isZh ? destination.place : destination.placeEn
                            )
                          ),
                        ]),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }